import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5783fd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "cropper-wrapper"
}
const _hoisted_2 = { class: "crop-nav" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "header__title" }
const _hoisted_5 = { class: "crop-controls" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-rotate-left" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Rotate")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-rotate-right" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Rotate")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close-light" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-crop" }, null, -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Done")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cropper = _resolveComponent("cropper")!
  const _component_app_loader = _resolveComponent("app-loader")!

  return (_ctx.image?.url)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_cropper, {
          ref: "crop",
          class: "cropper",
          "image-restriction": "stencil",
          src: _ctx.image.url,
          "stencil-size": !_ctx.isCaseCropper ? { width: '280', height: '280'} : null,
          "default-size": _ctx.isCaseCropper ? _ctx.defaultSize : null,
          "stencil-props": _ctx.isCaseCropper ? _ctx.caseStencil : _ctx.profileStencil,
          canvas: false,
          onReady: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loader = ''))
        }, null, 8, ["src", "stencil-size", "default-size", "stencil-props"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.hideRotateLeft)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "nav-btn",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleRotateLeft && _ctx.handleRotateLeft(...args)))
                }, _hoisted_8))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "nav-btn",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleRotateRight && _ctx.handleRotateRight(...args)))
            }, _hoisted_11),
            _createElementVNode("div", {
              class: "nav-btn",
              href: "javascript:void(0);",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('on-cancel')), ["prevent"]))
            }, _hoisted_14),
            _createElementVNode("div", {
              class: "nav-btn",
              href: "javascript:void(0);",
              onClickOnce: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleCrop && _ctx.handleCrop(...args)))
            }, _hoisted_17, 32)
          ])
        ]),
        (_ctx.loader)
          ? (_openBlock(), _createBlock(_component_app_loader, {
              key: 0,
              message: _ctx.loader
            }, null, 8, ["message"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}